import { Link } from 'react-router';

import styles from './StepCard.module.css';

interface StepCardProps {
  body: string;
  label: string;
  linkHref?: string;
  linkLabel?: string;
  title: string;
}

export function StepCard({
  body,
  label,
  linkHref,
  linkLabel,
  title,
}: StepCardProps) {
  return (
    <article className={styles.card}>
      <p className={styles.label}>{label}</p>
      <div className={styles.copy}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.body}>{body}</p>
      </div>
      {linkHref && linkLabel ? (
        <Link className={styles.link} to={linkHref}>
          {linkLabel}
        </Link>
      ) : null}
    </article>
  );
}
